type LogoutIconProps = {
	color?: string;
	height?: number;
	width?: number;
};
const LogoutIcon = ({ color, width, height }: LogoutIconProps) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width || 16}
			height={height || 16}
			viewBox='0 0 16 16'
			fill='none'
		>
			<path
				stroke={color || '#000'}
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth={1.14}
				d='M6 14H3.333A1.334 1.334 0 0 1 2 12.667V3.333A1.333 1.333 0 0 1 3.333 2H6M10.666 11.333 13.999 8l-3.333-3.333M14 8H6'
			/>
		</svg>
	);
};

export default LogoutIcon;
